export default{
  mobile(phoneNumber,userName){
      window.parent.postMessage({
            source: 'ccc-sdk',
            payload: {
              event: 'callOut',
              message: {
                    phoneNumber: phoneNumber,  // 必传
                    desc:userName // 呼出时系统显示字段，选填，没有时显示 phoneNumber
              }
            }
      }, '*')
  }
 }



// WEBPACK FOOTER //
// ./src/utils/phoneCall.js